import { render } from "./ListPICAndMemberSubCommunityView.vue?vue&type=template&id=efc23ea2"
import script from "./ListPICAndMemberSubCommunityView.vue?vue&type=script&lang=js"
export * from "./ListPICAndMemberSubCommunityView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__